import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { addRecord } from '../actions/popupdata/index'; // Adjust import for actions
import { deleteRecord, updateRecord } from '../actions/updatedata/index';
import { zillaTownData } from '../data/data';

const Popup = ({ isOpen, onClose, addRecord, updateRecord, deleteRecord, selectedItem }) => {
  const [formData, setFormData] = useState({
    id: null,
    // fatherName: '',
    name: '',
    // zilla: '',
    // town: '',
    // houseNumber: '',
    // area: '',
    // lossNumber: '',
    streetNumber: '',
    phone: '',
    // post: ''
  });

  // const [filteredZillas, setFilteredZillas] = useState([]);
  // const [filteredTowns, setFilteredTowns] = useState([]);
  // const [showZillaDropdown, setShowZillaDropdown] = useState(false);
  // const [showTownDropdown, setShowTownDropdown] = useState(false);

  // const modalRef = useRef(null);
  // const zillaDropdownRef = useRef(null);
  // const townDropdownRef = useRef(null);

  useEffect(() => {
    if (selectedItem) {
      setFormData(selectedItem);
    } else {
      resetFormData();
    }
  }, [selectedItem, isOpen]);

  // useEffect(() => {
  //   const handleOutsideClick = (e) => {
  //     if (
  //       modalRef.current && !modalRef.current.contains(e.target) &&
  //       (!zillaDropdownRef.current || !zillaDropdownRef.current.contains(e.target)) &&
  //       (!townDropdownRef.current || !townDropdownRef.current.contains(e.target))
  //     ) {
  //       // console.log('Closing dropdowns and modal');
  //       setShowZillaDropdown(false);
  //       setShowTownDropdown(false);
  //       onClose();
  //     }
  //   };

  //   document.addEventListener('mousedown', handleOutsideClick);

  //   return () => {
  //     document.removeEventListener('mousedown', handleOutsideClick);
  //   };
  // }, [onClose]);



  // useEffect(() => {
  //   const handleOutsideClick = (e) => {
  //     if (modalRef.current && !modalRef.current.contains(e.target)) {
  //       onClose();
  //     }
  
  //     if (zillaDropdownRef.current && !zillaDropdownRef.current.contains(e.target)) {
  //       setShowZillaDropdown(false); 
  //     }
  
  //     if (townDropdownRef.current && !townDropdownRef.current.contains(e.target)) {
  //       setShowTownDropdown(false);
  //     }
  //   };
  
  //   document.addEventListener('mousedown', handleOutsideClick);
  
  //   return () => {
  //     document.removeEventListener('mousedown', handleOutsideClick);
  //   };
  // }, [onClose]);
  


  const resetFormData = () => {
    setFormData({
      id: null,
      // fatherName: '',
      name: '',
      // zilla: '',
      // town: '',
      // houseNumber: '',
      // area: '',
      // lossNumber: '',
      streetNumber: '',
      phone: '',
      // post: ''
    });
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };



  // const handleZillaChange = (e) => {
  //   const zilla = e.target.value;
  //   setFormData({ ...formData, zilla, town: '' });
  //   setFilteredZillas(zillaTownData.filter(z => z.zilla.toLowerCase().includes(zilla.toLowerCase())));
  //   setShowZillaDropdown(true);
  //   setShowTownDropdown(false);
  // };



  // const handleTownChange = (e) => {
  //   const town = e.target.value;
  //   setFormData({ ...formData, town });
  //   if (formData.zilla) {
  //     const towns = zillaTownData.find(z => z.zilla === formData.zilla)?.towns || [];
  //     setFilteredTowns(towns.filter(t => t.toLowerCase().includes(town.toLowerCase())));
  //     setShowTownDropdown(true);
  //   }
  // };



  // const handleTownFocus = () => {
  //   if (formData.zilla) {
  //     const towns = zillaTownData.find(z => z.zilla === formData.zilla)?.towns || [];
  //     setFilteredTowns(towns);
  //     setShowTownDropdown(true);
  //   }
  // };
  
  // const handleTownChange = (e) => {
  //   const town = e.target.value;
  //   setFormData({ ...formData, town });
  //   if (formData.zilla) {
  //     const towns = zillaTownData.find(z => z.zilla === formData.zilla)?.towns || [];
  //     setFilteredTowns(towns.filter(t => t.toLowerCase().includes(town.toLowerCase())));
  //     setShowTownDropdown(true);
  //   }
  // };





  const handleSubmit = async () => {
    try {
      if (formData.id) {
        await axios.put(`https://mahboobezaat.com/db_connect.php?id=${formData.id}`, formData);
        updateRecord(formData);
      } else {
        const response = await axios.post('https://mahboobezaat.com/db_connect.php', formData);
        const newRecord = { ...formData, id: response.data.id }; // Assuming your API returns the new record with an ID
        addRecord(newRecord);
        window.location.reload();
      }
      onClose();
    } catch (error) {
      console.error("Error saving record:", error);
    }
  };

  const handleDelete = async () => {
    try {
      await axios.delete(`https://mahboobezaat.com/db_connect.php?id=${formData.id}`);
      deleteRecord(formData.id); // Dispatch action to delete record from Redux
      onClose();
    } catch (error) {
      console.error("Error deleting record:", error);
    }
  };

  // const { zilla, town, fatherName, name, houseNumber, area, lossNumber, streetNumber, phone, post } = formData;

  const { name,  streetNumber, phone } = formData;

  return (
    <div className={`modal ${isOpen ? 'show' : ''}`} style={{ display: isOpen ? 'block' : 'none' }} tabIndex="-1">
      {/* <div className="modal-dialog urdu-text" ref={modalRef}> */}
      <div className="modal-dialog urdu-text" >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{selectedItem ? 'Update Record' : 'Add New Record'}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className='row1 d-flex gap-3'>
              {/* <input type="text" className="form-control border-0 border-bottom text-end" id="fatherName" dir="rtl" value={fatherName} onChange={handleChange} placeholder="والد" /> */}
              <input type="text" className="form-control border-0 border-bottom text-end" id="name" dir="rtl" value={name} onChange={handleChange} placeholder="نام" />
            </div>

            {/* <div className='row1 d-flex gap-3 mt-3'>
              <div style={{ width: '50%', position: 'relative' }}>
                <input
                  type="text"
                  id="town"
                  className="form-control border-0 border-bottom text-end"
                  value={town}
                  onChange={handleTownChange}
                  onFocus={handleTownFocus} 
                  placeholder="ٹاؤن"
                  dir="rtl"
                  required
                />
                {showTownDropdown && filteredTowns.length > 0 && (
                  <ul className="dropdown-menu show" ref={townDropdownRef} style={styles.dropdownMenu}>
                    {filteredTowns.map(t => (
                      <li
                        key={t}
                        style={styles.dropdownItem}
                        onClick={() => {
                          setFormData({ ...formData, town: t });
                          setShowTownDropdown(false);
                        }}
                      >
                        {t}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              <div style={{ width: '50%', position: 'relative' }}>
                <input
                  type="text"
                  id="zilla"
                  className="form-control border-0 border-bottom text-end"
                  value={zilla}
                  onChange={handleZillaChange}
                   dir="rtl"
                  placeholder="ضلع"
                  required
                />
                {showZillaDropdown && filteredZillas.length > 0 && (
                  <ul className="dropdown-menu show" ref={zillaDropdownRef} style={styles.dropdownMenu}>
                    {filteredZillas.map(z => (
                      <li
                        key={z.zilla}
                        style={styles.dropdownItem}
                        onClick={() => {
                          setFormData({ ...formData, zilla: z.zilla, town: '' });
                          setShowZillaDropdown(false);
                        }}
                      > 
                        {z.zilla}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div> */}

            {/* <div className='row1 d-flex gap-3 mt-3'>
              <input type="tel" className="form-control border-0 border-bottom text-end" id="houseNumber" dir="rtl" value={houseNumber} onChange={handleChange}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, '');
                }}
                inputMode="numeric" placeholder="مکان نمبر" />
              <input type="text" className="form-control border-0 border-bottom text-end" id="area" dir="rtl" value={area} onChange={handleChange} placeholder="علاقہ" />
            </div> */}

            <div className='row1 d-flex gap-3 mt-3'>
              {/* <input type="tel" className="form-control border-0 border-bottom text-end" id="lossNumber" dir="rtl" value={lossNumber} onChange={handleChange}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, '');
                }}
                inputMode="numeric" placeholder="خسرہ نمبر" /> */}
              <input type="text" className="form-control border-0 border-bottom text-end" id="streetNumber" dir="rtl" value={streetNumber} onChange={handleChange} placeholder="پتہ" />
            </div>

            <div className='row1 d-flex mt-3'>
              <input
                type="tel"
                className="form-control border-0 border-bottom text-end"
                id="phone"
                value={phone}
                onChange={handleChange}
                inputMode="numeric"
                pattern="[0-9]*"
                 dir="ltr"
                placeholder="فون"
                // style={{ width: '50%' }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, '');
                }}
              />
              {/* <input
                type="tel"
                className="form-control border-0 border-bottom text-end"
                id="post"
                value={post}
                onChange={handleChange}
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="ڈاک خانہ"
                style={{ width: '50%' }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, '');
                }}
              /> */}
            </div>
          </div>

          <div className="modal-footer border-0 pt-3">
            {selectedItem && (
              <button type="button" className="btn btn-danger text-end me-2" onClick={handleDelete}>Delete</button>
            )}
            <button type="button" className="btn btn-outline-danger text-end" onClick={onClose}>Cancel</button>
            <button type="button" className="btn btn-success text-end" onClick={handleSubmit}>
              {selectedItem ? "Save And Update" : "Save"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  addRecord: (record) => {
    dispatch(addRecord(record));
  },
  updateRecord: (record) => {
    dispatch(updateRecord(record));
  },
  deleteRecord: (id) => {
    return dispatch(deleteRecord(id));
  }
});

export default connect(null, mapDispatchToProps)(Popup);

const styles = {
  dropdownMenu: {
    maxHeight: '150px',
    overflowY: 'auto',
    overflowX: 'hidden',
    position: 'absolute',
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    zIndex: 1000,
    width: '100%',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    padding: '0',
    margin: '0',
    listStyle: 'none'
  },
  dropdownItem: {
    padding: '8px 12px',
    cursor: 'pointer'
  },
  dropdownItemHover: {
    backgroundColor: '#f1f1f1'
  }
};
